import React from "react";
import { createRoot } from "react-dom/client";
import AppFrontal from "./app-frontal";
import "../config/i18n/i18next";
import * as serviceWorker from "../serviceWorker";

createRoot(document.getElementById("root")).render(<AppFrontal />);
serviceWorker.unregister();
